<div [id]="'system-notification-' + id"
     role="alert"
     [attr.aria-labelledby]="'system-notification-heading-' + id"
     class="system-notification__container flex flex--col u--1/1 bannerHeader"
     [ngClass]="'system-notification__container--' + type">

  <div class="system-notification__heading flex">
    <div class="system-notification__icon">
      <svg-icon [name]="icon"
                [svgStyle]="{ 'width.px': 12, 'height.px': 12, 'fill': iconColor }"
                [ngStyle]="{ height: '12px' }">
      </svg-icon>
    </div>

    <div class="u-pl---">
    <p class="text-12 u-mv0" >{{ descriptionText }}</p>
  </div>

   </div>
  
  <button aria-controls="system-notification"
  aria-pressed="false"
  type="button"
  aria-label="Dismiss this system notification"
  class="button--icon button button--icon-transparent"
  
  (click)="close.emit()">
<div class="system-notification__close-icon">
<svg-icon name="ico-close-16" [svgStyle]="{ 'width.px': 12, 'height.px': 12, 'fill': 'currentColor' }" [ngStyle]="{ height: '12px' }">
</svg-icon>
</div>
</button>
  
</div>

